import * as React from 'react';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions/index';
import { Overlay } from '../components/Overlay';
import { openURLFromLite } from 'utils';
import { trackEvent } from 'utils/Tracker';

export const WelcomeToBeatFlyerLite: React.FunctionComponent = () => {
  return (
    <Overlay title="👋 Welcome to Beatflyer Lite" hideCloseButton={true}>
      <p>
        Animate your layers independently combining powerful effects.
        <br />
        For more features like <strong>better rendering</strong>,{' '}
        <strong>ready-made teamplates</strong>,<br />
        <strong>music syncronization,</strong> and{' '}
        <strong>audio visualizers</strong>,{' '}
        <strong>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              openURLFromLite('https://editor.beatflyer.com');
              trackEvent('clickedViewPro', { location: 'welcome' });
            }}
            target="blank"
          >
            try Beatflyer Pro
          </a>
        </strong>
        .
      </p>
      <button
        onClick={() => {
          parent.postMessage({ didReadIntro: true }, '*');
          storeDispatch(Actions.closeModal());
        }}
        className="large primary"
      >
        Let's start
      </button>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/showcase/WelcomeToBeatFlyerLite.tsx